import React, { useEffect, createElement } from 'react';
import { GuidePage } from './pages/GuidePage';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1093523303837505');
    window.fbq('track', 'PageView');
  }, []);
  return <GuidePage data-id="element-0" />;
}